module.exports = __webpack_public_path__ + "assets/img/product-government1.df1ef2fa.png";